import React from "react";
import NcvtePageSection from "../../Sections/NcvtePageSection/Content";
const NcvteProgramPage = () => {
  return <NcvtePageSection />;
};

export default NcvteProgramPage;
